import { Enums, SurveyType } from "./enums";
//General Constants
// export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
// export const ERROR_REPORT_EMAIL = 'jon.hay@sysdocgroup.com';
/**
 * Default application services.
 * This is a list of the services that can be registered with the
 * application DI container.
 */
export enum Services {}

export const LOG_LEVEL_NAMES = {
  [Enums.LogLevel.Diagnostics]: "Diagnostics",
  [Enums.LogLevel.Info]: "Info",
  [Enums.LogLevel.Warning]: "Warning",
  [Enums.LogLevel.Error]: "Error"
};

export const COMPANY_SIZE_OPTIONS = [
  { key: 1, label: "1 - 100 people" },
  { key: 2, label: "101 - 500 people" },
  { key: 3, label: "501 - 1000 people" },
  { key: 4, label: "1001 - 5000 people" },
  { key: 5, label: "5000+ people" }
];

export const IMPACT_TYPE_OPTIONS = [
  { key: Enums.ImpactType.PEOPLE, label: "phrases.people" },
  { key: Enums.ImpactType.PROCESS, label: "phrases.process" },
  { key: Enums.ImpactType.TECHNOLOGY, label: "phrases.technology" }
];

export const IMPACT_LEVEL_OPTIONS = [
  { key: Enums.ImpactLevel.LOW, label: "phrases.low" },
  { key: Enums.ImpactLevel.MEDIUM, label: "phrases.medium" },
  { key: Enums.ImpactLevel.HIGH, label: "phrases.high" },
  { key: Enums.ImpactLevel.UNKNOWN, label: "phrases.unknown" }
];
export const BULK_UPDATE_IMPACT_LEVEL_OPTIONS = [
  { key: Enums.ImpactLevelBulkUpdate.LOW, label: "phrases.low" },
  { key: Enums.ImpactLevelBulkUpdate.MEDIUM, label: "phrases.medium" },
  { key: Enums.ImpactLevelBulkUpdate.HIGH, label: "phrases.high" }
];

export const IMPACT_LEVELS_DROPDOWN = ["High", "Medium", "Low"];

export const STAKEHOLDER_FEELING_OPTIONS = [
  { key: Enums.ImpactLevel.LOW, label: "phrases.concerned" },
  { key: Enums.ImpactLevel.MEDIUM, label: "phrases.neutral" },
  { key: Enums.ImpactLevel.HIGH, label: "phrases.advocate" },
  { key: Enums.ImpactLevel.UNKNOWN, label: "phrases.unknown" }
];

export const MITIGATION_CONFIDENCE_OPTIONS = [
  { key: Enums.MitigationConfidence.LOW, label: "phrases.low" },
  { key: Enums.MitigationConfidence.MEDIUM, label: "phrases.medium" },
  { key: Enums.MitigationConfidence.HIGH, label: "phrases.high" },
  { key: Enums.MitigationConfidence.UNKNOWN, label: "phrases.unknown" }
];

export const PROGRESS_STATUS_OPTIONS = [
  { key: Enums.ProgressStatus.NOT_STARTED, label: "phrases.notStarted" },
  { key: Enums.ProgressStatus.IN_PROGRESS, label: "phrases.inProgress" },
  { key: Enums.ProgressStatus.COMPLETED, label: "phrases.completed" },
  { key: Enums.ProgressStatus.ONHOLD, label: "phrases.onHold" },
  { key: Enums.ProgressStatus.CANCELLED, label: "phrases.cancelled" }
];

export const SURVEY_TYPE_OPTIONS = [
  { key: SurveyType.General, label: "phrases.general" },
  { key: SurveyType.Readiness, label: "phrases.readiness" },
  { key: SurveyType.ChangeBarometer, label: "phrases.changeBarometer" }
];

export const ZERO_TO_TEN_OPTIONS = [
  { key: -1, label: "phrases.unknown" },
  { key: 0, label: "phrases.unknown" },
  { key: 1, label: "phrases.low" },
  { key: 2, label: "phrases.low" },
  { key: 3, label: "phrases.low" },
  { key: 4, label: "phrases.low" },
  { key: 5, label: "phrases.medium" },
  { key: 6, label: "phrases.medium" },
  { key: 7, label: "phrases.medium" },
  { key: 8, label: "phrases.high" },
  { key: 9, label: "phrases.high" },
  { key: 10, label: "phrases.high" }
];

export const COMMITMENT_PROFILING_OPTIONS = [
  { key: -1, label: "phrases.unknown" },
  { key: 0, label: "phrases.unknown" },
  { key: 1, label: "phrases.blocker" },
  { key: 2, label: "phrases.critic" },
  { key: 3, label: "phrases.challenger" },
  { key: 4, label: "phrases.generalUnderstanding" },
  { key: 5, label: "phrases.personalUnderstanding" },
  { key: 6, label: "phrases.activeSupporter" },
  { key: 7, label: "phrases.champion" },
  { key: 8, label: "phrases.adopter" },
  { key: 9, label: "phrases.embedSustain" },
  { key: 10, label: "phrases.adaptImprove" }
];

export const SENTIMENT_RECEPTIVENESS_OPTIONS = [
  { key: -1, label: "phrases.unknown" },
  { key: 0, label: "phrases.unknown" },
  { key: 1, label: "phrases.concerned" },
  { key: 2, label: "phrases.concerned" },
  { key: 3, label: "phrases.concerned" },
  { key: 4, label: "phrases.concerned" },
  { key: 5, label: "phrases.neutral" },
  { key: 6, label: "phrases.neutral" },
  { key: 7, label: "phrases.neutral" },
  { key: 8, label: "phrases.advocate" },
  { key: 9, label: "phrases.advocate" },
  { key: 10, label: "phrases.advocate" }
];

export const TIMELINE_PROGRESS_STATUS_OPTIONS = [
  { key: Enums.ProgressStatus.NOT_STARTED, label: "phrases.notStarted" },
  { key: Enums.ProgressStatus.IN_PROGRESS, label: "phrases.inProgress" },
  { key: Enums.ProgressStatus.COMPLETED, label: "phrases.completed" },
  { key: Enums.ProgressStatus.OVERDUE, label: "phrases.overdue" }
];

export const IMPACT_STATUS_OPTIONS = [
  { key: Enums.ProgressStatus.NOT_STARTED, label: "phrases.notStarted" },
  { key: Enums.ProgressStatus.IN_PROGRESS, label: "phrases.inProgress" },
  { key: Enums.ProgressStatus.COMPLETED, label: "phrases.mitigated" }
];

export const RAG_STATUS_OPTIONS = [
  { key: Enums.RagStatus.UNKNOWN, label: "phrases.unknown" },
  { key: Enums.RagStatus.RED, label: "phrases.red" },
  { key: Enums.RagStatus.AMBER, label: "phrases.amber" },
  { key: Enums.RagStatus.GREEN, label: "phrases.green" }
];

export const KEY_CONCERN_STATUS_OPTIONS = [
  { key: Enums.ConcernStatus.ACTIVE, label: "phrases.active" },
  { key: Enums.ConcernStatus.CLOSED, label: "phrases.closed" },
  { key: Enums.ConcernStatus.IRRELEVANT, label: "phrases.noLongerRelevant" }
];

export const MILESTONE_TYPE_OPTIONS = [
  { key: Enums.MilestoneType.GO_LIVE, label: "phrases.goLive" },
  { key: Enums.MilestoneType.COMMS, label: "phrases.comms" },
  { key: Enums.MilestoneType.CHANGE_PLAN, label: "phrases.changePlan" },
  { key: Enums.MilestoneType.ORG_ANNOUNCEMENT, label: "phrases.orgAnnouncement" },
  { key: Enums.MilestoneType.READINESS, label: "phrases.readiness" },
  { key: Enums.MilestoneType.TRAINING, label: "phrases.training" },
  { key: Enums.MilestoneType.ENGAGEMENT_ACTIVITY, label: "phrases.engagementActivity" },
  { key: Enums.MilestoneType.UAT, label: "phrases.uat" },
  { key: Enums.MilestoneType.DESIGN_CONFIGURATION, label: "phrases.designConfig" },
  { key: Enums.MilestoneType.DATA_MT, label: "phrases.dataMT" },
  { key: Enums.MilestoneType.HYPERCARE, label: "phrases.hypercare" },
  { key: Enums.MilestoneType.STAGEGATE, label: "phrases.stageGate" },
  { key: Enums.MilestoneType.OTHER, label: "phrases.other" }
];

export const DEFAULT_DATE: string = "0001-01-01T00:00:00";

export const PERMISSION_SCOPE_OPTIONS = [
  {
    key: Enums.PermissionScope.ADMIN,
    label: "phrases.admin",
    isAssignable: false
  },
  {
    key: Enums.PermissionScope.OWNER,
    label: "phrases.owner",
    isAssignable: true
  },
  {
    key: Enums.PermissionScope.CONTRIBUTOR,
    label: "phrases.contributor",
    isAssignable: true
  },
  {
    key: Enums.PermissionScope.NOACCESS,
    label: "phrases.noAccess",
    isAssignable: false
  },
  {
    key: Enums.PermissionScope.READER,
    label: "phrases.reader",
    isAssignable: true
  }
];

export const ORGANISATION_PERMISSION_SCOPE_OPTIONS = [
  {
    key: Enums.PermissionScope.OWNER,
    label: "phrases.owner",
    isAssignable: true
  },
  {
    key: Enums.PermissionScope.CONTRIBUTOR,
    label: "phrases.contributor",
    isAssignable: true
  },
  {
    key: Enums.PermissionScope.READER,
    label: "phrases.reader",
    isAssignable: true
  }
];

export const PROJECT_PERMISSION_SCOPE_OPTIONS = [
  {
    key: Enums.PermissionScope.OWNER,
    label: "phrases.owner",
    isAssignable: true,
    permissionActivity: "phrases.ownerActivity"
  },
  {
    key: Enums.PermissionScope.CONTRIBUTOR,
    label: "phrases.contributor",
    isAssignable: true,
    permissionActivity: "phrases.contributorActivity"
  },
  {
    key: Enums.PermissionScope.READER,
    label: "phrases.reader",
    isAssignable: true,
    permissionActivity: "phrases.readerActivity"
  }
];

export const GetI18nParsedList = (i18n, data, key = "label") => {
  data.forEach(e => GetI18nParsed(i18n, e, key));
  return data;
};

export const GetI18nParsed = (i18n, item, key = "label") => {
  let label = item[key] + "";
  if (
    label.startsWith("phrases.") ||
    label.startsWith("forms.") ||
    label.startsWith("placeholders.") ||
    label.startsWith("tables.")
  ) {
    item[key] = i18n.t(label);
  }
  return item;
};

export const IMPACT_REPORT_GROUPS = [
  { key: "businessAreas", label: "phrases.businessAreas" },
  { key: "stakeholders", label: "phrases.stakeholderAudience" }
];

export const REVIEW_DATE_RANGE_OPTIONS = [
  { key: Enums.ReviewRange.FOUR_TO_SIX_WEEKS, label: "phrases.reviewRange_FourToSixWeeks" },
  { key: Enums.ReviewRange.TWO_TO_FOUR_WEEKS, label: "phrases.reviewRange_TwoToFourWeeks" },
  { key: Enums.ReviewRange.WITHIN_TWO_WEEKS, label: "phrases.reviewRange_WithinTwoWeeks" },
  { key: Enums.ReviewRange.OVERDUE, label: "phrases.reviewRange_Overdue" }
];

export const DEBOUNCE_DELAY = {
  FAST: 250,
  NORMAL: 500,
  SLOW: 750
};

export const FORM_COL = {
  FULL_WIDTH: "col-12",
  HALF_WIDTH: "col-6",
  THIRD_WIDTH: "col-4"
};

export const USER_IMAGE_PLACEHOLDER = (firstName: string, lastName: string) =>
  `https://eu.ui-avatars.com/api/?background=fff&color=00135d&name=${firstName || "N"}+${lastName || "A"}`;
export const NAME_IMAGE_PLACEHOLDER = (firstName: string) =>
  `https://eu.ui-avatars.com/api/?background=fff&color=00135d&name=${firstName || "NA"}`;

export const LOCAL_STORAGE_FILTERS = {
  IMPACTS: "filters.impacts",
  ACTIONS: "filters.actions",
  STAKEHOLDERS: "filters.stakeholders",
  AUDIENCES: "filters.audiences",
  IMPACTGROUPS: "filters.impactgroups",
  PROJECT_TEAM_USERS: "filters.projectTeamUsers",
  PROJECT_INDIVIDUAL_USERS: "filters.projectIndividualUsers",
  USERS: "filters.users"
};

export const HEATMAP_FILTERS = {
  BUSINESS_AREA: "Business Area"
};

export const REMOVE_UNSAFE_CHARACTERS = (value: string) => value.replace(/[^A-Z0-9\s_!()@./#&+-=]/gi, "").trim();

export const HUB_URL = {
  PROJECT_ARTIFACTS_REPORTING: "project-artifacts-reporting"
};

export const parseUrlForProgrammeId = (path: string) => {
  let exp = new RegExp(/\/organisations\/(.*?)\/programmes\/(.*?)($|\/+)/g);
  var match = exp.exec(path);
  if (!exp.test(path) && match === null) return [null, null];
  let orgId = match.length > 1 ? +match[1] : null;
  let programmeId = match.length > 2 ? +match[2] : null;
  return [orgId, programmeId];
};

export const parseUrlForProjectId = (path: string) => {
  let exp = new RegExp(/\/organisations\/(.*?)\/projects\/(.*?)($|\/+)/g);
  var match = exp.exec(path);
  if (!exp.test(path) && match === null) return [null, null];
  let orgId = match.length > 1 ? +match[1] : null;
  let projectId = match.length > 2 ? +match[2] : null;
  return [orgId, projectId];
};

export const RouteParams = {
  organisationId: ":organisationId",
  programmeId: ":programmeId",
  projectId: ":projectId",
  actionId: ":actionId",
  impactId: ":impactId",
  impactGroupId: ":impactGroupId",
  type: ":type",
  page: ":page",
  section: ":section",
  stakeholderId: ":stakeholderId",
  stakeholderType: ":stakeholderType",
  profilingType: ":profilingType",
  userId: ":userId",
  benefitId: ":benefitId",
  surveyId: ":surveyId"
};

export const BASE_ROUTE = `organisations/${RouteParams.organisationId}`;

export const CHANGE_BAROMETER_TEMPLATE = {
  title: "New Change Barometer",
  description:
    "Presales tool to inform the resourcing and costing of Change Management Solutions based on project size and complexity, change capability and capacity and other key risks.",
  templateInjected: true,
  pages: [
    {
      name: "Intro Questions",
      title: "Intro Questions",
      templateInjected: true,
      elements: [
        {
          type: "text",
          name: "Customer Name",
          title: "Customer Name",
          templateInjected: true
        },
        {
          type: "text",
          name: "Opportunity Number",
          title: "Opportunity Number",
          templateInjected: true
        },
        {
          name: "What type of industry does the company operate within?",
          title: "What type of industry does the company operate within?",
          type: "dropdown",
          description: "(Select from the drop down)",
          choices: [
            { value: "Item 1", text: "Automotive" },
            { value: "Item 2", text: "Aerospace & Defence" },
            { value: "Item 3", text: "Food & Beverage" },
            { value: "Item 4", text: "Distribution" },
            { value: "Item 5", text: "Manufacturing" },
            { value: "Item 6", text: "Fashion" },
            { value: "Item 7", text: "Retail Supply Chain" },
            { value: "Item 8", text: "Chemicals" },
            { value: "Item 9", text: "Engineering & Construction" },
            { value: "Item 10", text: "Healthcare" },
            { value: "Item 11", text: "Public Sector" },
            { value: "Item 12", text: "Financial Services" }
          ],
          showOtherItem: true,
          otherPlaceholder: "Write here...",
          otherText: "Other - Please Note",
          templateInjected: true
        },
        {
          name: "Which CloudSuite and / or Solution(s) are being positioned?",
          title: "Which CloudSuite and / or Solution(s) are being positioned?",
          type: "tagbox",
          description: "(Select from the drop down)",
          choices: [
            { value: "Item 1", text: "CloudSuite Industrial SMB (Syteline)" },
            { value: "Item 2", text: "CloudSuite Manufacturing" },
            { value: "Item 3", text: "CloudSuite Automotive" },
            { value: "Item 4", text: "CloudSuite A&D" },
            { value: "Item 5", text: "CloudSuite Food & Beverage" },
            { value: "Item 6", text: "CloudSuite Distribution Enterprise" },
            { value: "Item 7", text: "CloudSuite Distribution SMB (SX.e)" },
            { value: "Item 8", text: "CloudSuite Fashion" },
            { value: "Item 9", text: "CloudSuite Chemicals" },
            { value: "Item 10", text: "CloudSuite Engineering & Construction" },
            { value: "Item 11", text: "CloudSuite Healthcare" },
            { value: "Item 12", text: "CloudSuite Public Sector" },
            { value: "Item 13", text: "CloudSuite Corporate" },
            { value: "Item 14", text: "Supply Chain Management" },
            { value: "Item 15", text: "Workforce Management (WFM)" },
            { value: "Item 16", text: "Warehouse Management System (WMS)" },
            { value: "Item 17", text: "Configure Price Quote (CPQ PCM)" },
            { value: "Item 18", text: "Human Resources (HCM)" },
            { value: "Item 19", text: "Birst" },
            { value: "Item 20", text: "PLM" }
          ],
          showOtherItem: true,
          otherPlaceholder: "Write here...",
          otherText: "Other - Please Note",
          templateInjected: true
        }
      ]
    },
    {
      name: "Size",
      title: "Size",
      templateInjected: true,
      elements: [
        {
          type: "radiogroup",
          name: "What size is the customer?",
          title: "What size is the customer?",
          choices: [
            { value: "1", text: "1. Small" },
            { value: "2", text: "2. Medium" },
            { value: "3", text: "3. Large" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 0,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Size"
        },
        {
          type: "radiogroup",
          name: "What is the anticipated duration of the programme?",
          title: "What is the anticipated duration of the programme?",
          choices: [
            { value: "1", text: "1. 8 - 12 Months" },
            { value: "2", text: "2. 12 - 18 Months" },
            { value: "3", text: "3. 18 Months Plus" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 0,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Size"
        },
        {
          type: "radiogroup",
          name: "How many business units and/or functions are in scope?",
          title: "How many business units and/or functions are in scope?",
          choices: [
            { value: "1", text: "1. 10 or More" },
            { value: "2", text: "2. 6 - 9" },
            { value: "3", text: "3. Less than 5" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Size"
        },
        {
          type: "radiogroup",
          name: "How many end users are impacted overall?",
          title: "How many end users are impacted overall?",
          choices: [
            { value: "1", text: "1. Small - Less than 100" },
            { value: "2", text: "2. Medium - 100 to 250" },
            { value: "3", text: "3. Large - 250 plus" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Size"
        },
        {
          type: "radiogroup",
          name: "How many locations and countries are in scope?",
          title: "How many locations and countries are in scope?",
          choices: [
            { value: "1", text: "1. More than Three" },
            { value: "2", text: "2. Two to Three" },
            { value: "3", text: "3. One" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Size"
        },
        {
          type: "radiogroup",
          name: "How many languages or unique business cultures are in scope?",
          title: "How many languages or unique business cultures are in scope?",
          choices: [
            { value: "1", text: "1. More than Three" },
            { value: "2", text: "2. Two to Three" },
            { value: "3", text: "3. One" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Size"
        }
      ]
    },
    {
      name: "Complexity",
      title: "Complexity",
      templateInjected: true,
      elements: [
        {
          type: "radiogroup",
          name: "What is the nature of the programme?",
          title: "What is the nature of the programme?",
          choices: [
            { value: "1", text: "1. Low" },
            { value: "2", text: "2. Medium" },
            { value: "3", text: "3. High" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 0,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Complexity"
        },
        {
          type: "radiogroup",
          name: "What is the proposed roll out strategy?",
          title: "What is the proposed roll out strategy?",
          choices: [
            { value: "1", text: "1. Very Complex" },
            { value: "2", text: "2. Complex" },
            { value: "3", text: "3. Less Complex" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Complexity"
        },
        {
          type: "radiogroup",
          name: "How standard are the customer’s current processes to Infor future state?",
          title: "How standard are the customer’s current processes to Infor future state?",
          choices: [
            { value: "1", text: "1. Low proportion" },
            { value: "2", text: "2. Medium proportion" },
            { value: "3", text: "3. High proportion" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 0,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Complexity"
        },
        {
          type: "radiogroup",
          name: "What proportion of roles and responsibilities will need to change?",
          title: "What proportion of roles and responsibilities will need to change?",
          choices: [
            { value: "1", text: "1. Low" },
            { value: "2", text: "2. Medium" },
            { value: "3", text: "3. High" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 0,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Complexity"
        }
      ]
    },
    {
      name: "Capability and Capacity",
      title: "Capability and Capacity",
      templateInjected: true,
      elements: [
        {
          type: "radiogroup",
          name: "What change capabilities are available to support the programme?",
          title: "What change capabilities are available to support the programme?",
          choices: [
            { value: "1", text: "1. Low" },
            { value: "2", text: "2. Medium" },
            { value: "3", text: "3. High" }
          ],
          templateInjected: true,
          magnitudeWeight: 0,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Capability and Capacity"
        },
        {
          type: "radiogroup",
          name: "How many competing change programmes are running?",
          title: "How many competing change programmes are running?",
          choices: [
            { value: "1", text: "1. Three or More" },
            { value: "2", text: "2. Two to Three" },
            { value: "3", text: "3. One" }
          ],
          templateInjected: true,
          magnitudeWeight: 1,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Capability and Capacity"
        }
      ]
    },
    {
      name: "Leadership and Readiness",
      title: "Leadership and Readiness",
      templateInjected: true,
      elements: [
        {
          type: "radiogroup",
          name: "Are business leaders engaged and fully supportive?",
          title: "Are business leaders engaged and fully supportive?",
          choices: [
            { value: "1", text: "1. Negative" },
            { value: "2", text: "2. Neutral" },
            { value: "3", text: "3. Positive" }
          ],
          templateInjected: true,
          magnitudeWeight: 0,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Leadership and Readiness"
        },
        {
          type: "radiogroup",
          name: "What is the organizations history of change?",
          title: "What is the organizations history of change?",
          choices: [
            { value: "1", text: "1. Negative" },
            { value: "2", text: "2. Neutral" },
            { value: "3", text: "3. Positive" }
          ],
          templateInjected: true,
          magnitudeWeight: 0,
          readinessWeight: 1,
          magnitudePossible: 3,
          readinessPossible: 3,
          dimension: "Leadership and Readiness"
        }
      ]
    }
  ]
};

export const containsFilterOptions = [
  {
    id: Enums.ConditionFilterKey.OR,
    name: "Contains: Either"
  },
  {
    id: Enums.ConditionFilterKey.AND,
    name: "Contains: All"
  }
];

export const ParseToJson = obj => {
  if (!obj) {
    return [];
  }
  if (typeof obj === "string") {
    return JSON.parse(obj);
  }
  return obj;
};
